import { gql } from 'apollo-angular';

export const ACCOUNTS = gql`
  query accounts($search: String,$accountType: AccountType) {
    accounts(search: $search, accountType: $accountType) {
      id
      accountType
      accountName
      accountCode
      level
      parentAccountId
      parentAccountData {
        id
        accountType
        accountName
        accountCode
        level
        parentAccountId
        isControl
        status
        createdAt
        updatedAt
      }
      isControl
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_ACCOUNT_BY_ID = gql`
  query  ($id: Int!) {
    account(id: $id) {
      id
      accountType
      accountName
      accountCode
      level
      parentAccountId
      parentAccountData {
        id
        accountType
        accountName
        accountCode
        level
        parentAccountId
        isControl
        status
        createdAt
        updatedAt
      }
      isControl
      status
      createdAt
      updatedAt
    }
  }
`;
